import { render, staticRenderFns } from "./FrogetPwd.vue?vue&type=template&id=6ca08f54&scoped=true&"
import script from "./FrogetPwd.vue?vue&type=script&lang=js&"
export * from "./FrogetPwd.vue?vue&type=script&lang=js&"
import style0 from "./FrogetPwd.vue?vue&type=style&index=0&id=6ca08f54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca08f54",
  null
  
)

export default component.exports